import { api } from './backend'; 

export const list =(page, limit, filters)=> api.get('/front/videos-playlists',{ params: { page, limit, ...filters }});  

export const findBySlugName = (data) => api.get(`/front/videos/${data}`);